import type { NotificationStatus } from '../types';

/**
 * Names the channels a notification ACTUALLY went out on, from the statuses the API returned.
 *
 * Returns null when nothing went out, so a caller cannot accidentally announce a send — the
 * absence has to be handled rather than falling through to a cheerful default.
 *
 * Deliberately takes only statuses. The defect this replaces read the channel off
 * `taxReturn?.clientPhone`: whether a number EXISTS on the return, which says nothing about
 * whether a text was delivered to it. See the 2026-08-26 Maria Stopa incident, where a number was
 * on file, the text was accepted and billed, and it still did not arrive in time to be usable.
 */
export function sentChannelLabel(
  emailStatus?: NotificationStatus,
  smsStatus?: NotificationStatus
): string | null {
  // 'pending' is "accepted for delivery", which is precisely the claim that misled everyone in the
  // incident. Only these two count as gone.
  const wentOut = (s?: NotificationStatus) => s === 'sent' || s === 'delivered';

  const email = wentOut(emailStatus);
  const sms = wentOut(smsStatus);

  if (email && sms) return 'email & SMS';
  if (email) return 'email';
  if (sms) return 'SMS';
  return null;
}
